<template>
  <div class="notice-contain" :class="{ 'show-notice': showNotice }" :style="{ width: facility == 'pc' ? '300px' : '1.2rem' }">
    <div class="notice-close" @click="clickClose">
      <i class="el-icon-close"></i>
    </div>
    <div class="notice-type">系统通知</div>
    <div class="notice-title">
      {{ title }}
    </div>
    <div class="notice-content" v-html="content"></div>
    <div class="notice-btns">
      <button class="notice-btn" @click="clickClose">我知道了</button>
    </div>
  </div>
</template>

<script>
import { readNotice } from '@/api/notice'
export default {
  data () {
    return {
      noticeId: '',
      title: '',
      content: '',
      type: '',
      showNotice: false,
      facility: 'pc',
    }
  },
  methods: {
    show (data) {
      this.facility = sessionStorage.getItem("facility")
      this.title = data.title
      this.content = data.x_content
      this.type = data.type;
      this.showNotice = true
      this.noticeId = data.id
    },
    clickClose () {
      // 设置已读
      readNotice({ notice_id: this.noticeId, type: this.type })
      this.close()
    },
    close () {
      this.showNotice = false
      this.$emit('close')
    }
  }

}
</script>

<style lang="scss" scoped>
.notice-contain {
  position: fixed;
  right: 20px;
  bottom: -100%;
  background-color: #FFF;
  border: 1px solid #dedede;
  border-radius: 4px;
  transition: bottom 1s ease-in-out;
  padding: 30px 20px 20px;
  z-index: 5000;

  .notice-close {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;

    .el-icon-close {
      color: #B3B3B3;
      font-size: 18px;
    }
  }

  .notice-type {
    color: #2C9645;
    font-weight: bold;
    font-size: 14px;
    text-align: center;
    margin-bottom: 20px;
  }

  .notice-title {
    font-size: 12px;
    padding: 10px;
    background: rgba(0, 0, 0, 0.06);
    border-radius: 6px;
    margin-bottom: 10px;
  }

  .notice-content {
    font-size: 12px;
    word-break: break-all;
    max-height: 50vh;
    overflow-y: auto;
    margin-bottom: 10px;

    img {
      max-width: 100% !important;
    }
  }

  .notice-btns {
    text-align: center;

    .notice-btn {
      width: 137px;
      height: 34px;
      line-height: 1.2;
      background: #2c9645;
      border-radius: 6px;
      font-size: 14px;
      color: #FFF;
      cursor: pointer;
    }
  }
}

.show-notice {
  bottom: 10px;
}
</style>